import classNames from 'classnames'
import React from 'react'
import type { Translate } from 'types'

import Tooltip from '@mui/material/Tooltip'

interface Props {
  iconClassName: string
  localeKey: string
  translate: Translate
}

function FloorSpaceTooltip({ iconClassName, localeKey, translate }: Props) {
  return (
    <Tooltip title={translate(localeKey) as string} placement="top">
      <i className={classNames('fm', iconClassName)} />
    </Tooltip>
  )
}

export default FloorSpaceTooltip
